const ANALYTICS_ROUTE_PATTERNS = [
  '/login',
  '/register',
  '/activation',
  '/password-reset',
  '/password-reset/confirm',
  '/auth/github/callback',
  '/auth/gitlab/callback',
  '/auth/microsoft/callback',
  '/cli/authorize',
  '/paddle-checkout',
  '/org-invites/accept',
  '/project-invites/accept',
  '/dashboard',
  '/organizations',
  '/organizations/:orgSlug/users',
  '/organizations/:orgSlug/billing',
  '/organizations/:orgSlug/settings',
  '/organizations/:orgSlug/projects',
  '/organizations/:orgSlug/projects/:projectSlug',
  '/organizations/:orgSlug/projects/:projectSlug/dashboard',
  '/organizations/:orgSlug/projects/:projectSlug/members',
  '/organizations/:orgSlug/projects/:projectSlug/history',
  '/organizations/:orgSlug/projects/:projectSlug/settings',
  '/organizations/:orgSlug/projects/:projectSlug/user-properties',
  '/organizations/:orgSlug/projects/:projectSlug/channels/:channelId/bundles',
  '/projects',
  '/projects/:slug',
  '/projects/:projectSlug/dashboard',
  '/projects/:projectSlug/members',
  '/projects/:projectSlug/history',
  '/projects/:projectSlug/user-properties',
  '/projects/:projectSlug/settings',
  '/projects/:projectSlug/channels/:channelId/bundles',
  '/user/settings',
  '/user/notifications',
  '/user/tokens',
] as const;

const escapeRegex = (value: string): string =>
  value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const ANALYTICS_ROUTES = ANALYTICS_ROUTE_PATTERNS.map(pattern => ({
  pattern,
  matcher: new RegExp(
    `^${pattern
      .split('/')
      .map(segment => (segment.startsWith(':') ? '[^/]+' : escapeRegex(segment)))
      .join('/')}/?$`,
    'i'
  ),
}));

const stripQueryAndFragment = (locationValue: string): string =>
  locationValue.split(/[?#]/, 1)[0] || '/';

export const resolveAnalyticsPagePath = (locationValue: string): string | null => {
  const pathname = stripQueryAndFragment(locationValue);
  if (pathname === '/') {
    return null;
  }

  return (
    ANALYTICS_ROUTES.find(route => route.matcher.test(pathname))?.pattern ?? '/not-found'
  );
};

export const buildAnalyticsPageLocation = (pagePath: string, origin: string): string =>
  `${origin.replace(/\/$/, '')}${pagePath}`;
